<template>
  <table class="usa-table usx-table">
    <caption>
      {{
        caption
      }}
    </caption>
    <thead>
      <tr>
        <th scope="col" v-for="(col, index) in columns" :key="index">
          {{ col.label }}
        </th>
        <th scope="col" v-if="downloadButton">Download</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) in items"
        :key="index"
        :class="{ hover: hover, odd: index % 2 != 0 }"
      >
        <td
          v-for="(col, index2) in columns"
          :key="index2"
          @click="onClick(item)"
        >
          <span>
            {{ item[col.key] }}
          </span>
        </td>
        <td v-if="downloadButton">
          <button
            class="usa-button"
            type="submit"
            v-on:click.stop="downloadClicked(item)"
          >
            Download
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { upperFirst, map } from "lodash";
export default {
  name: "USWDSTable",
  props: {
    caption: {
      type: String,
      default: "",
    },
    hover: {
      type: Boolean,
      default: false,
    },
    downloadButton: {
      type: Boolean,
      default: false,
    },
    items: {
      type: [Array, Object],
      default: null,
    },
    fields: {
      type: [Array, Object],
      default: null,
    },
  },
  emits: ["rowClicked", "downloadClicked"],
  data() {
    return {
      columns: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let cols = [];
      if (this.fields) {
        map(this.fields, (item) => {
          if (typeof item == "string") {
            cols.push({ key: item, label: this.toTitleCase(item) });
          } else {
            if (item.key) {
              if (!item.label) {
                item.label = this.toTitleCase(item.key);
              }
              if (
                typeof item.isActive == "undefined" ||
                item.isActive !== false
              ) {
                cols.push(item);
              }
            }
          }
        });
      } else {
        map(Object.keys(this.items[0]), (key) => {
          cols.push({ key: key, label: this.toTitleCase(key) });
        });
      }

      this.columns = cols;
    },
    onClick(row) {
      this.$emit("rowClicked", row);
    },
    downloadClicked(row) {
      this.$emit("downloadClicked", row);
    },
    toTitleCase(str) {
      str = str.replace(/-|_/g, " ");
      let words = str.split(" ");
      words = map(words, upperFirst);
      str = words.join(" ");
      return upperFirst(str);
    },
  },
};
</script>
<style lang="scss">
.usx-table {
  table {
    display: table !important;
  }
  .odd td {
    background-color: rgba(0, 0, 0, 0.2);
  }
  .hover {
    &:hover {
      background-color: rgba(209, 236, 241, 1);
      cursor: pointer;
    }
    &:hover td {
      background-color: transparent;
    }
  }
}
</style>
